import React from 'react';

import {
  KEYBOARD_SHORTCUT_SECTIONS,
  KEYBOARD_SHORTCUTS_FOOTNOTES,
} from './keyboardShortcuts.config';

const WIDE_SECTION_TITLES = new Set(['Align & distribute']);

function KeyboardShortcutsGuide({
  showHeading = true,
  layout = 'flyout',
}: {
  showHeading?: boolean;
  layout?: 'flyout' | 'modal';
}) {
  const isModal = layout === 'modal';

  return (
    <div
      className={`keyboard-shortcuts-info${
        isModal ? ' keyboard-shortcuts-info--modal' : ''
      }`}
    >
      {showHeading ? <div className="heading">Keyboard shortcuts</div> : null}
      <p className="keyboard-shortcuts-intro">
        Use these shortcuts while the canvas or editor is focused. They match the top-bar
        undo, redo, and zoom controls.
        {isModal ? (
          <>
            {' '}
            <span className="keyboard-shortcuts-platform-legend">
              Mac shortcuts are listed first, then Windows.
            </span>
          </>
        ) : null}
      </p>

      <div
        className={
          isModal ? 'keyboard-shortcuts-grid' : 'keyboard-shortcuts-stack'
        }
      >
        {KEYBOARD_SHORTCUT_SECTIONS.map((section) => (
          <div
            key={section.title}
            className={`info-details-wrap keyboard-shortcuts-section${
              isModal && WIDE_SECTION_TITLES.has(section.title)
                ? ' keyboard-shortcuts-section--wide'
                : ''
            }`}
          >
            <div className="sub-heading">{section.title}</div>
            <table
              className={`keyboard-shortcuts-table${
                isModal ? ' keyboard-shortcuts-table--compact' : ''
              }`}
            >
              <thead>
                <tr>
                  <th scope="col">Action</th>
                  {isModal ? (
                    <th scope="col">Shortcut</th>
                  ) : (
                    <>
                      <th scope="col">Mac</th>
                      <th scope="col">Windows</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {section.rows.map((row) => (
                  <tr key={`${section.title}-${row.action}`}>
                    <td>
                      {row.action}
                      {row.note ? (
                        <span className="keyboard-shortcuts-note">{row.note}</span>
                      ) : null}
                    </td>
                    {isModal ? (
                      <td>
                        <span className="keyboard-shortcuts-keys">
                          <kbd>{row.mac}</kbd>
                          <span
                            className="keyboard-shortcuts-keys-sep"
                            aria-hidden
                          >
                            /
                          </span>
                          <kbd>{row.windows}</kbd>
                        </span>
                      </td>
                    ) : (
                      <>
                        <td>
                          <kbd>{row.mac}</kbd>
                        </td>
                        <td>
                          <kbd>{row.windows}</kbd>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>

      <ul className="keyboard-shortcuts-footnotes">
        {KEYBOARD_SHORTCUTS_FOOTNOTES.map((note) => (
          <li key={note}>{note}</li>
        ))}
      </ul>
    </div>
  );
}

export default KeyboardShortcutsGuide;
